// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Includes inherited overrides from: core -> theme-avneue-no-vendor -> repli-sandbox-avneue-no-vendor -> beck-at-wells-branch
// Generated: 2026-10-05T18:31:58.250Z
// Counts: 1 design, 17 content, 22 slot group, 0 collection binding, 3 section, 0 style

export const designOverrides = {
  "design._site.color.primary": {
    "cssVariable": "--vibe-color-primary",
    "overrideType": "VALUE",
    "value": "#0095ff",
    "mappedField": null
  }
};

export const contentOverrides = {
  "apartment-sync.javascript_id": {
    "overrideType": "VALUE",
    "customValue": "asdfasdfasdf",
    "generatedValue": null,
    "mappedField": null
  },
  "propertyoverview.title": {
    "overrideType": "VALUE",
    "customValue": "110 Royyyyy",
    "generatedValue": null,
    "mappedField": null
  },
  "amenitycardgrid.subheading": {
    "overrideType": "VALUE",
    "customValue": "<p>From sun-soaked afternoons by the pool to cozy evenings by the fire, every shared space at Beck at Wells Branch is designed for the way you want to live. Explore the amenities that make our North Austin community feel like home.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "ctasection.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Discover Everything <span data-type=\"field-token\" data-field=\"property_name\"></span> Has in Store</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "featuredamenities.apartmentBlurbSubtitle": {
    "overrideType": "VALUE",
    "customValue": "<p>Thoughtful finishes in every detail</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "featuredamenities.apartmentBlurbText": {
    "overrideType": "VALUE",
    "customValue": "<p>Step inside to open floor plans crowned with sleek granite, a ceramic tile backsplash, and warm wood-style flooring underfoot. Sink into a garden tub, cozy up to a wood-burning fireplace, or let the light pour through your private sunroom. Every home is finished with care, ready for the personal touches that make it yours.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "featuredamenities.apartmentBlurbTitle": {
    "overrideType": "VALUE",
    "customValue": "<p>Designed Around the Way You Live</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "featuredamenities.communityBlurbSubtitle": {
    "overrideType": "VALUE",
    "customValue": "<p>Resort-style living in the heart of Wells Branch</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "featuredamenities.communityBlurbText": {
    "overrideType": "VALUE",
    "customValue": "<p>Slip into the sparkling pool, break a sweat in the fitness center, or trade stories with neighbors around the fireside lounge and outdoor kitchen. Between the bark park, disc golf, and a Starbucks-stocked Wi-Fi café, every shared space is designed to turn ordinary days into something you look forward to. This is where a North Austin lifestyle truly comes together.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "featuredamenities.communityBlurbTitle": {
    "overrideType": "VALUE",
    "customValue": "<p>Room to Gather, Space to Unwind</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "featuredamenities.heading": {
    "overrideType": "VALUE",
    "customValue": "<p>Discover Our Signature Amenities</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "featuredamenities.subheading": {
    "overrideType": "VALUE",
    "customValue": "<p>From sunlit poolside afternoons to spirited workouts and easy gatherings with neighbors, every amenity at Beck at Wells Branch is designed to elevate the everyday. Take a closer look at the spaces that make life here feel like a getaway you never have to leave.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "gallery.apartment_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Our spacious one, two, and three-bedroom homes are designed with comfort and style in mind, featuring open floor plans, sleek granite countertops, stainless steel appliances, and wood-style flooring. Select residences add wood-burning fireplaces, garden tubs, sunrooms, and private patios or balconies. With walk-in closets and in-home washer and dryer connections, there's a thoughtfully appointed layout to fit the way you live.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "gallery.community_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Life at Beck at Wells Branch centers on resort-style gathering spaces, from the sparkling swimming pool framed by lush North Austin greenery to the state-of-the-art fitness center, fireside lounge, and outdoor grilling stations. Sip a complimentary latte at the resident Starbucks café, work from the Wi-Fi lounge, or unwind beneath the shaded pergolas. With planned social activities and a dedicated on-site team, it's easy to relax, connect, and feel right at home.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "hero.learn_more": {
    "overrideType": "VALUE",
    "customValue": "<p>Beck at Wells Branch offers spacious one, two, and three-bedroom homes from 698 to 1,415 square feet, each finished with granite countertops, stainless steel appliances, and generous walk-in closets. Residents enjoy a sparkling resort-style pool, a state-of-the-art fitness center, a Starbucks café and Wi-Fi lounge, a bark park, and an outdoor kitchen for weekend gatherings. Tucked into North Austin's Wells Branch with easy access to I-35 and MoPac, you're minutes from Apple, Dell, HP, and Samsung, all within the highly regarded Round Rock ISD.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "hero.romance_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Picture mornings that begin with a fresh Starbucks coffee in the Wi-Fi lounge and afternoons that melt away by the resort-style pool. At Beck at Wells Branch, granite counters, hardwood-style floors, and sun-filled walk-in closets turn everyday living into something a little more elevated. This is North Austin the way it was meant to feel—spacious, social, and effortlessly yours.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "petpolicy.intro": {
    "overrideType": "VALUE",
    "customValue": "<p>At Beck at Wells Branch, your four-legged family members are right at home. With our on-site Bark Park, dog washing station, and lush, pet-friendly grounds—plus private first-floor yards on select homes—there's plenty of room for tails to wag in our welcoming Austin community.</p>",
    "generatedValue": null,
    "mappedField": null
  }
};

export const slotGroupOverrides = {
  "amenitycardgrid.card_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "alt": {
        "type": "VALUE",
        "customValue": "Resort-style swimming pool with lounge chairs and lush landscaping."
      },
      "title": {
        "type": "VALUE",
        "customValue": "Resort-Style Pool"
      },
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162864/019cfdda-741f-728e-825b-113ef274cf42.webp"
      },
      "description": {
        "type": "VALUE",
        "customValue": "Take a refreshing dip or stretch out on a lounge chair beneath the Texas sun. Our sparkling resort-style pool is the perfect place to unwind, socialize, and soak up sunny afternoons."
      }
    }
  },
  "amenitycardgrid.card_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "alt": {
        "type": "VALUE",
        "customValue": "Fitness center with cardio machines and weight equipment"
      },
      "title": {
        "type": "VALUE",
        "customValue": "Fitness Center"
      },
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162864/019cfdda-5c4b-73a9-a4d3-a53a5f9203f0.webp"
      },
      "description": {
        "type": "VALUE",
        "customValue": "Break a sweat without leaving home in our state-of-the-art fitness center, stocked with cardio machines, weights, and everything you need to power through your routine on your own schedule."
      }
    }
  },
  "amenitycardgrid.card_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "alt": {
        "type": "VALUE",
        "customValue": "Community coffee bar with a Starbucks logo, modern stools, and decorative items."
      },
      "title": {
        "type": "VALUE",
        "customValue": "Resident Wifi Lounge & Starbucks Café"
      },
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162864/019cfdda-4d42-70d8-9435-575f6dadaf44.webp"
      },
      "description": {
        "type": "VALUE",
        "customValue": "Grab a complimentary Starbucks coffee and settle into our stylish Wi-Fi lounge. It's the ideal spot to catch up on work, meet a neighbor, or simply savor a quiet moment to yourself."
      }
    }
  },
  "amenitycardgrid.card_4": {
    "sourceIndex": null,
    "fieldOverrides": {
      "alt": {
        "type": "VALUE",
        "customValue": "Outdoor grilling area with built-in grills, dining table, and seating."
      },
      "title": {
        "type": "VALUE",
        "customValue": "Community Outdoor Kitchen"
      },
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162864/019d5743-2c5f-717f-b646-6c3f46a40d6b.webp"
      },
      "description": {
        "type": "VALUE",
        "customValue": "Fire up the grills and gather your friends at our outdoor kitchen and seating area. From weekend cookouts to easy evening dinners, it's where great food and good company come together."
      }
    }
  },
  "amenitycardgrid.card_5": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162864/019cfdda-822b-77d2-b751-c69e7323ab5e.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Spacious seating area with leather sofas and armchairs, a patterned rug, and Union Jack ottomans."
      },
      "title": {
        "type": "GENERATOR",
        "generatedValue": "Clubhouse"
      },
      "description": {
        "type": "GENERATOR",
        "generatedValue": "Gather with neighbors or find a quiet corner to unwind in our welcoming clubhouse, where comfortable seating and a warm, inviting atmosphere make it easy to feel right at home."
      }
    }
  },
  "ctasection.card1_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162864/019cfdda-5aef-77fd-8b1f-5620891951da.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Modern living and dining area with dark gray sofa and table."
      }
    }
  },
  "ctasection.card2_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162864/019cfdda-9105-7706-9e5a-2ac1580d4596.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Beck at Wells Branch Premier Apartments monument sign with address 2801"
      }
    }
  },
  "ctasection.card3_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://multihubmedia.com/cdn-cgi/image/format=auto/property/6767906449162864/019cfdda-db5a-7282-96e2-7e00866b188a.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Luxury apartment complex swimming pool with lounge chairs and surrounding trees."
      }
    }
  },
  "ctasection.card4_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162864/019cfdda-741f-728e-825b-113ef274cf42.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Resort-style swimming pool with lounge chairs and lush landscaping."
      }
    }
  },
  "featuredamenities.card_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "alt": {
        "type": "VALUE",
        "customValue": "Resort-style swimming pool with lounge chairs and lush landscaping."
      },
      "title": {
        "type": "VALUE",
        "customValue": "Resort-Style Pool"
      },
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162864/019cfdda-741f-728e-825b-113ef274cf42.webp"
      },
      "description": {
        "type": "VALUE",
        "customValue": "Soak up the Texas sunshine and cool off with a refreshing dip in our sparkling resort-style pool, framed by lush landscaping and plenty of lounge seating for laid-back afternoons."
      }
    }
  },
  "featuredamenities.card_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "alt": {
        "type": "VALUE",
        "customValue": "Fitness center with cardio machines and weight equipment"
      },
      "title": {
        "type": "VALUE",
        "customValue": "State-of-the-Art Fitness Center"
      },
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162864/019cfdda-5c4b-73a9-a4d3-a53a5f9203f0.webp"
      },
      "description": {
        "type": "VALUE",
        "customValue": "Stay energized without leaving home in our fully equipped fitness center, complete with cardio machines, weights, and everything you need for a complete workout on your schedule."
      }
    }
  },
  "featuredamenities.card_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "alt": {
        "type": "VALUE",
        "customValue": "Community coffee bar with a Starbucks logo, modern stools, and decorative items."
      },
      "title": {
        "type": "VALUE",
        "customValue": "Resident WiFi Lounge & Starbucks Café"
      },
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162864/019cfdda-4d42-70d8-9435-575f6dadaf44.webp"
      },
      "description": {
        "type": "VALUE",
        "customValue": "Sip a complimentary Starbucks brew and settle into our stylish WiFi lounge—the perfect spot to work remotely, catch up with neighbors, or simply unwind."
      }
    }
  },
  "featuredamenities.card_4": {
    "sourceIndex": null,
    "fieldOverrides": {
      "alt": {
        "type": "VALUE",
        "customValue": "Outdoor grilling area with built-in grills, dining table, and seating."
      },
      "title": {
        "type": "VALUE",
        "customValue": "Community Outdoor Kitchen"
      },
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162864/019d5743-2c5f-717f-b646-6c3f46a40d6b.webp"
      },
      "description": {
        "type": "VALUE",
        "customValue": "Fire up the grill and gather friends at our outdoor kitchen, where built-in grilling stations and comfortable seating make every cookout an effortless celebration."
      }
    }
  },
  "gallery.hero_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162864/019cfdda-741f-728e-825b-113ef274cf42.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Resort-style swimming pool with lounge chairs and lush landscaping."
      }
    }
  },
  "gallery.hero_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162864/019cfdda-6576-72dc-a645-65ace9b5f53e.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Lobby area with leather chairs, coffee table, and bar."
      }
    }
  },
  "gallery.hero_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162864/019cfdda-8bf1-70fe-aedf-d0f059ad89a9.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Modern kitchen with granite countertops and stainless steel appliances, opening to a living room with a plush sofa and artwork."
      }
    }
  },
  "petpolicy.feature_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162864/019d5743-06dc-74dc-b22e-d2afdddf7652.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Outdoor seating area with pergolas, sofas, and coffee tables."
      }
    }
  },
  "petpolicy.lifestyle_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162864/019d5743-2c5f-717f-b646-6c3f46a40d6b.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Outdoor grilling area with built-in grills, dining table, and seating."
      }
    }
  },
  "propertyoverview.feature_image_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://multihubmedia.com/cdn-cgi/image/format=auto/property/6767906449162864/019cfdda-741f-728e-825b-113ef274cf42.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Resort-style swimming pool with lounge chairs and lush landscaping."
      }
    }
  },
  "propertyoverview.feature_image_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162864/019cfdda-8bf1-70fe-aedf-d0f059ad89a9.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Modern kitchen with granite countertops and stainless steel appliances, opening to a living room with a plush sofa and artwork."
      }
    }
  },
  "propertyoverview.feature_image_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162864/019cfdda-5c4b-73a9-a4d3-a53a5f9203f0.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Fitness center with cardio machines and weight equipment"
      }
    }
  },
  "propertyoverview.feature_image_4": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162864/019cfdda-675f-739b-ba7c-52725f7de38b.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Bedroom with a king-sized bed, dresser, and walk-in closet."
      }
    }
  }
};

export const collectionBindingOverrides = {};

export const sectionOverrides = {
  "_global": [
    {
      "sectionId": "google-tag-manager",
      "blockId": "google-tag-manager",
      "position": 0
    },
    {
      "sectionId": "json-ld-schema",
      "blockId": "json-ld-schema",
      "position": 0
    }
  ],
  "floor-plans": [
    {
      "sectionId": "apartment-sync",
      "blockId": "apartment-sync",
      "position": 3
    }
  ]
};

export const styleOverrides = {};
